import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateLocationMutationVariables = Types.Exact<{
  input: Types.CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'LocationPayload', location?: { __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateLocationMutationVariables = Types.Exact<{
  input: Types.ActivateLocationInput;
}>;


export type ActivateLocationMutation = { __typename?: 'Mutation', activateLocation: { __typename?: 'LocationPayload', location?: { __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivateLocationMutationVariables = Types.Exact<{
  input: Types.InactivateLocationInput;
}>;


export type InactivateLocationMutation = { __typename?: 'Mutation', inactivateLocation: { __typename?: 'LocationPayload', location?: { __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateLocationNameMutationVariables = Types.Exact<{
  input: Types.UpdateLocationNameInput;
}>;


export type UpdateLocationNameMutation = { __typename?: 'Mutation', updateLocationName: { __typename?: 'LocationPayload', location?: { __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateLocationAddressMutationVariables = Types.Exact<{
  input: Types.UpdateLocationAddressInput;
}>;


export type UpdateLocationAddressMutation = { __typename?: 'Mutation', updateLocationAddress: { __typename?: 'LocationPayload', location?: { __typename?: 'LocationDocument', id: string, tenantId: string, name: string, parentLocationId: string, siteParentId: string, locationType: Types.LocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateLocationDocument = new TypedDocumentString(`
    mutation CreateLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    location {
      ...LocationDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const ActivateLocationDocument = new TypedDocumentString(`
    mutation ActivateLocation($input: ActivateLocationInput!) {
  activateLocation(input: $input) {
    location {
      ...LocationDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const InactivateLocationDocument = new TypedDocumentString(`
    mutation InactivateLocation($input: InactivateLocationInput!) {
  inactivateLocation(input: $input) {
    location {
      ...LocationDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateLocationNameDocument = new TypedDocumentString(`
    mutation UpdateLocationName($input: UpdateLocationNameInput!) {
  updateLocationName(input: $input) {
    location {
      ...LocationDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const UpdateLocationAddressDocument = new TypedDocumentString(`
    mutation UpdateLocationAddress($input: UpdateLocationAddressInput!) {
  updateLocationAddress(input: $input) {
    location {
      ...LocationDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment LocationDetails on LocationDocument {
  id
  tenantId
  name
  parentLocationId
  siteParentId
  locationType
  erpId
  status
  created
  updated
  address {
    ...AddressData
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateLocation: build.mutation<CreateLocationMutation, CreateLocationMutationVariables>({
      query: (variables) => ({ document: CreateLocationDocument, variables })
    }),
    ActivateLocation: build.mutation<ActivateLocationMutation, ActivateLocationMutationVariables>({
      query: (variables) => ({ document: ActivateLocationDocument, variables })
    }),
    InactivateLocation: build.mutation<InactivateLocationMutation, InactivateLocationMutationVariables>({
      query: (variables) => ({ document: InactivateLocationDocument, variables })
    }),
    UpdateLocationName: build.mutation<UpdateLocationNameMutation, UpdateLocationNameMutationVariables>({
      query: (variables) => ({ document: UpdateLocationNameDocument, variables })
    }),
    UpdateLocationAddress: build.mutation<UpdateLocationAddressMutation, UpdateLocationAddressMutationVariables>({
      query: (variables) => ({ document: UpdateLocationAddressDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateLocationMutation, useActivateLocationMutation, useInactivateLocationMutation, useUpdateLocationNameMutation, useUpdateLocationAddressMutation } = injectedRtkApi;
